
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ServiceInsightsPhotoObject } from '../types/service-insights-export-photo.types';
import { ServiceInsightsphotoObjectDefault } from '../components/export-photo/export-photo-constants';


@Injectable({
  providedIn: 'root'
})
export class ServiceInsightsExportPhotoService {

  private serviceInsightsPhotoObjectSubject: BehaviorSubject<ServiceInsightsPhotoObject> = new BehaviorSubject<ServiceInsightsPhotoObject>(ServiceInsightsphotoObjectDefault);
  serviceInsightsPhotoObject: Observable<ServiceInsightsPhotoObject> = this.serviceInsightsPhotoObjectSubject.asObservable();


    setServiceInsightsPhotoObject(photoUrls: ServiceInsightsPhotoObject | undefined) {
        if(photoUrls) {
            this.serviceInsightsPhotoObjectSubject.next(photoUrls);
        }
    }

  private isExportPhotoViewSubject = new BehaviorSubject<boolean>(false);
  isExportPhotoViewObervable = this.isExportPhotoViewSubject.asObservable();

  setIsExportPhotoView(value: boolean) {
    this.isExportPhotoViewSubject.next(value);
  }
}

